import script from "./AppModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppModal.vue?vue&type=script&setup=true&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=2c250876&lang=css"

const __exports__ = script;

export default __exports__